import { render, staticRenderFns } from "./SettingAccount.vue?vue&type=template&id=73f4ae94&"
import script from "./SettingAccount.vue?vue&type=script&lang=js&"
export * from "./SettingAccount.vue?vue&type=script&lang=js&"
import style0 from "./SettingAccount.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports